import React from 'react';
import Modal from 'react-modal';
import './ConfirmationModal.scss';

Modal.setAppElement('#root');

const ConfirmationModal = ({ isOpen, message, onConfirm, onGoBack }) => (
    <Modal
        isOpen={isOpen}
        onRequestClose={onGoBack}
        contentLabel="Confirm time selection"
        overlayClassName="confirmation-modal-overlay"
        className="confirmation-modal-content"
        style={{ overlay: {}, content: {} }}
        shouldReturnFocusAfterClose={false}
    >
        <div className="confirmation-modal">
            <p>{message}</p>
            <div className="confirmation-modal-buttons">
                <button className="submit-button" onClick={onGoBack}>
                    Go Back
                </button>
                <button className="submit-button" onClick={onConfirm}>
                    Confirm
                </button>
            </div>
        </div>
    </Modal>
);

export default ConfirmationModal;
